import { formatNumber } from "@";
import React, { memo } from "react";

const ChartsTooltip = ({ active, payload, label, prefix = "المبلغ" }) => {
  if (active && payload && payload.length) {
    return (
      <div
        dir="rtl"
        className="overflow-hidden rounded-2xl border border-gray-100 bg-white/95 shadow-xl shadow-gray-900/10 backdrop-blur-md transition-opacity duration-300 dark:border-gray-700/60 dark:bg-gray-900/95 dark:shadow-black/40"
      >
        {/* Header strip */}
        <div className="border-b border-gray-100 bg-gradient-to-l from-purple-50/60 to-transparent px-3 py-1.5 dark:border-gray-700/60 dark:from-purple-950/40">
          <strong className="text-[11px] font-semibold uppercase tracking-[0.14em] text-purple-700 dark:text-purple-300">
            {label}
          </strong>
        </div>
        {/* Body */}
        <div className="space-y-1 px-3 py-2 text-start">
          {payload.map((item, index) => (
            <div
              key={index}
              className="flex items-center gap-2 text-sm text-gray-700 dark:text-gray-300"
            >
              {item.color && (
                <span
                  aria-hidden
                  className="block h-2 w-2 rounded-full shadow-sm ring-2 ring-white dark:ring-gray-900"
                  style={{ backgroundColor: item.color }}
                />
              )}
              {prefix && (
                <span className="text-xs text-gray-500 dark:text-gray-400">
                  {prefix}:
                </span>
              )}
              <strong className="ms-auto inline-block tabular-nums tracking-tight text-gray-900 dark:text-gray-100">
                {formatNumber(item.value)}
              </strong>
            </div>
          ))}
        </div>
      </div>
    );
  }
  return null;
};

export default memo(ChartsTooltip);
